module.exports = __webpack_public_path__ + "media/images/bnr-edge-ef95fe66413704038b9609bb7878c242.svg";